require('./style.less');

var Marionette = require('marionette');


module.exports = Marionette.LayoutView.extend({

    id: 'fr-action-row-wr',

    initialize: function(options) {

        this.channel = options.channel;

    },

    template: require('./template.hbs'),

    serializeData: function() {


        var state = this.channel.request('state'),
            searchResults = state.get('searchResults'),

            numberHits = searchResults.getNumberOfHits(),
            appliedHits = searchResults.getAppliedHits(),
            numberAppliedHits = appliedHits.length,
            appliedHitsExist = numberAppliedHits > 0;

        var msg = numberAppliedHits + ' / ' + numberHits + ' hits selected';


        if ( appliedHitsExist ) {

            var pagesAndSearchesWithHitsApplied = {
                pageIds: [],
                searchIds: []
            };

            appliedHits.reduce( function( prev, curr ) {

                if (curr.get('isApplied')) {

                    var pageId = curr.get('pageId'),
                        searchId = curr.get('searchModelId');

                    if ( prev.pageIds.indexOf( pageId ) < 0 ) {
                        prev.pageIds.push( pageId );
                    }

                    if ( prev.searchIds.indexOf( searchId) < 0) {
                        prev.searchIds.push( searchId );
                    }
                }

                return prev;

            }, pagesAndSearchesWithHitsApplied );

            msg += ' from ' + pagesAndSearchesWithHitsApplied.pageIds.length + ' page' + ( pagesAndSearchesWithHitsApplied.pageIds.length > 1 ? 's' : '');

            if ( pagesAndSearchesWithHitsApplied.searchIds.length > 1 ) {
                msg += ' and ' + pagesAndSearchesWithHitsApplied.searchIds.length + ' searches';
            }

        }

        msg = '(' + msg + ')';

        return {
            message: msg,
            appliedHitsExist: appliedHitsExist
        };

    },

    ui: {
        applyButton:            '#fr-apply',
        numberHitsIncludedDiv:  '#fr-n-hits-selected' // for now not a view, no events or anything
    },

    events: {
        'click @ui.applyButton': 'onApply'
    },

    onApply: function() {

        this.channel.trigger( 'findAndRedact:apply' );

    }

});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/findAndRedact/layout/resultsView/hitsActionRow/view.js
 ** module id = 635
 ** module chunks = 0
 **/